/**
* reducers for the investment
*
* Created by Tom on 20/06/18
*/

import C from '../constants'

const initState = {
    iLoading: false,
    iData: []
}

export const investmentState = (state = initState, action) => {

    switch(action.type) {

        // in case of `iLoading` change
        case C.SET_INVESTMENT_LOADER:
            return {
                ...state,
                iLoading: action.payload
            }

        // in case of `iData` change
        case C.SET_INVESTMENT_DATA:
            return {
                ...state,
                iData: action.payload
            }

        default: return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/investmentReducers.js